'use client';

import React from "react";
import Script from "next/script";
const TOLT_PUBLIC_KEY = process.env.NEXT_PUBLIC_TOLT_PUBLIC_KEY || process.env.NEXT_PUBLIC_TOLT_KEY || "";
const TOLT_REF_HYDRATION_SCRIPT = `
  (function () {
    try {
      var REF_CODE_PATTERN = /^[A-Za-z0-9_-]+$/;
      var cleanRefCode = function (value) {
        var trimmed = (value || "").trim();
        if (!trimmed) return null;
        var withoutBraces = trimmed.replace(/^\\{+|\\}+$/g, "").trim();
        return REF_CODE_PATTERN.test(withoutBraces) ? withoutBraces : null;
      };
      var params = new URLSearchParams(window.location.search || "");
      var queryRef = cleanRefCode(params.get("ref"));
      var storedRef = cleanRefCode(window.localStorage.getItem("affiliateRefCode"));
      var resolvedRef = queryRef || storedRef;
      if (!resolvedRef) return;
      window.localStorage.setItem("affiliateRefCode", resolvedRef);
      window.tolt_referral = resolvedRef;
    } catch (e) {
      // No-op: referral hydration is best-effort.
    }
  })();
`;
export function LayoutJSIncludes({
  children
}: {
  children?: React.ReactNode;
}): React.ReactElement {
  return <>
        <Script id="tolt-ref-hydration" strategy="beforeInteractive" data-sentry-element="Script" data-sentry-source-file="LayoutJSIncludes.tsx">
            {TOLT_REF_HYDRATION_SCRIPT}
        </Script>
        {TOLT_PUBLIC_KEY ? <Script id="tolt-sdk" strategy="beforeInteractive" src="https://cdn.tolt.io/tolt.js" data-tolt={TOLT_PUBLIC_KEY} /> : null}
        <>
            {children}
        </>
    </>;
}